// extracted by mini-css-extract-plugin
export default {"body":"History_body__frAAd","table":"History_table__3PsTn","red":"History_red__N4XdE"};